import { OptionItem } from 'tno-core';

export const Languages = [
  new OptionItem('English (Canada)', 'en-CA'),
  new OptionItem('French (Canada)', 'fr-CA'),
  new OptionItem('Chinese (China)', 'zh-CN'),
  new OptionItem('Punjabi (India)', 'pa-IN'),
  new OptionItem('Spanish (Mexico)', 'es-MX'),
];
